import { metrics } from '@atlassian/browser-metrics';

export const APP_DISCOVERY_TTI_THRESHOLD = 4000;
export const APP_DISCOVERY_TTR_THRESHOLD = 1000;

export const appsDiscoveryPageLoad = metrics.pageLoad({
	key: 'service-management.app-discovery',
	slo: {
		fmp: {
			initial: { threshold: APP_DISCOVERY_TTR_THRESHOLD },
			transition: { threshold: APP_DISCOVERY_TTR_THRESHOLD },
		},
		tti: {
			initial: { threshold: APP_DISCOVERY_TTI_THRESHOLD },
			transition: { threshold: APP_DISCOVERY_TTI_THRESHOLD },
		},
	},
});
